import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


const About = () => {



  return (
    <div>

      <div className='mt-10 text-center px-3' data-aos="fade-up" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="350">
        <h1 className='text-xl font-bold underline text-main'>
           אודות
        </h1>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          דבורה היא מומחית אסתטיקאית מנוסה ומייסדת "שביל דבורה", קליניקה להסרת שיער וטיפוח העור.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          עם התחייבות למשך כל חייה לעזור לנשים להשיג עור חלק וזוהר, היא מתגאה ביכולתה לתקן פגמים במיומנות שרכשה ולשפר את איכות ומרקם העור.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          הגיעו אל הקליניקה המתקדמת, וחוו בתחושת חדשנות הסרת שיער וטיפולי עור.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-bold px-2 text-main' dir='rtl'>
          ההכשרה הבינלאומית של דבורה והדאגה האמיתית לאנשים  מאפשרת להתנתק מהזמן ולהנות מטיפוח מפנק.
        </p>
      </div>

    </div>

  )

}


export default About